import React, { lazy } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/326VeAMMbzfc2xhaDM3TT9/hf_20260301_203344_3261ae83-06cc-4ce6-b5fa-905be4ea50e4.jpg';
export function ProductReveal() {
  return <section className="py-10 md:py-20 px-4 bg-cream" data-id="element-215">
      <div className="max-w-4xl mx-auto text-center" data-id="element-216">
        <p className="text-caramel-dark font-bold tracking-widest uppercase mb-4" data-id="element-217">
          Te presento…
        </p>

        <h2 className="text-5xl md:text-6xl font-heading font-extrabold text-brown-dark mb-4 md:mb-6 drop-shadow-sm" data-id="element-218">
          FLANES SIN HORNO
        </h2>

        <p className="text-xl md:text-2xl text-gray-700 font-medium mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-219">
          "El método simple para convertir tu cocina en un extra real (sin
          horno, sin estrés)"
        </p>

        <div className="max-w-lg mx-auto mb-6 md:mb-10" data-id="element-220">
          <div className="rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-221">
            <img src={PRODUCT_IMAGE} alt="Flanes Sin Horno — El Método Completo" className="w-full h-auto object-cover" loading="lazy" data-id="element-222" />
          </div>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border border-caramel/20 max-w-2xl mx-auto mb-8 md:mb-12" data-id="element-223">
          <ul className="space-y-4 text-left" data-id="element-224">
            <li className="flex items-center text-lg font-semibold text-brown-dark" data-id="element-225">
              <CheckCircleIcon className="w-6 h-6 text-success-green mr-3 flex-shrink-0" data-id="element-226" />
              60+ recetas (incluye la selección principal + extras)
            </li>
            <li className="flex items-center text-lg font-semibold text-brown-dark" data-id="element-227">
              <CheckCircleIcon className="w-6 h-6 text-success-green mr-3 flex-shrink-0" data-id="element-228" />
              11 salsas irresistibles
            </li>
            <li className="flex items-center text-lg font-semibold text-brown-dark" data-id="element-229">
              <CheckCircleIcon className="w-6 h-6 text-success-green mr-3 flex-shrink-0" data-id="element-230" />
              Paso a paso para que puedas empezar aunque seas principiante
            </li>
          </ul>
        </div>

        <p className="text-lg text-gray-800 font-medium text-center max-w-2xl mx-auto" data-id="element-231">
          Aquí recibes las recetas que MÁS salida tienen, con un método claro,
          pensado para que lo puedas hacer en casa.
        </p>
      </div>
    </section>;
}